import React from "react";
import "./Shop.scss";

function ShopScreen() {
  return <div className="Shop">Available Soon.</div>;
}

export default ShopScreen;
